import React from 'react'
import { useActivityContext } from './Context'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { ShowHistoryButton } from './ShowHistoryButton'

export const AddNewActivityButton = ({ text = 'Add new activity...' }: { text?: string }) => {
  const { setShowInput, disabled, showInput } = useActivityContext()

  return (
    <ShowIf condition={!disabled}>
      <HorizontalStack gap={2}>
        <HorizontalStack className="justify-content-start py-2">
          <BusyButtonLink
            disabled={disabled}
            bsSize="sm"
            icon="comments"
            text={text}
            onClick={() => setShowInput(true)}
          />
        </HorizontalStack>
        <ShowIf condition={!showInput}>
          <ShowHistoryButton />
        </ShowIf>
      </HorizontalStack>
    </ShowIf>
  )
}
